class VwIslemtanimRaporDTO {
    id: number = null;
    organizasyonId?: number = null;
    islemtanimId?: number = null;
    raporsorguId?: number = null;
    yasbaslangic?: number = null;
    yasbitis?: number = null;
    cinsiyetId?: number = null;
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptal?: string = "H";
    fkIptalneden?: number = null;
    iptalTarihi?: string = null;
    iptalKullanici?: number = null;
    adi?: string = "";
    aktif?: string = "";
}
export default VwIslemtanimRaporDTO;